export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/cvs-health.9acb4bad.svg","height":69,"width":141,"blurWidth":0,"blurHeight":0};